import { render } from "./OverAllDownload.vue?vue&type=template&id=322e20dc&scoped=true"
import script from "./OverAllDownload.vue?vue&type=script&lang=js"
export * from "./OverAllDownload.vue?vue&type=script&lang=js"

import "./OverAllDownload.vue?vue&type=style&index=0&id=322e20dc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-322e20dc"]])

export default __exports__